module.exports = __webpack_public_path__ + "media/store/fonts/States-Var-7302d15b8b22e4c38115cd6dad7a0fbe.woff2";